import { Table as AntdTable } from 'antd';
import { TableProps } from 'antd/lib/table';
import React, { FC } from 'react';
import styled from 'styled-components';
import { TableSkeleton } from 'components/atoms/table';

const StyledTable = styled(AntdTable)`
  .ant-table-ping-right:not(.ant-table-has-fix-right)
    .ant-table-container::after {
    box-shadow: none;
  }

  .ant-table-thead > tr > th {
    background: var(--coolest-gray-20);
    font-weight: var(--heading-6-weight);
    height: var(--spacing-07);
    padding: 0 var(--spacing-05);
    line-height: var(--spacing-05);
    border-bottom: 0px;
  }

  .ant-table-column-sorters {
    padding: 0;
  }

  .ant-table-cell-fix-left {
    background: #fffffff2;
  }

  .ant-table-thead > tr > th.ant-table-cell-fix-left {
    background: #ededeff2;
  }
`;

export const Table: FC<TableProps<any>> = (props) => {
  const { loading, size } = props;

  return loading ? <TableSkeleton size={size} /> : <StyledTable {...props} />;
};
